import braftEditor from "./braftEditor";
import home from "./home";
import login from "./login";
import robotsList from "./robotsList";
import createChatGroup from "./createChatGroup";
import avatar from "./avatar";
import applicationSearch from "./applicationSearch";

export default { home, login, robotsList, braftEditor, createChatGroup, avatar, applicationSearch };
